import PlatformTestScenarios from './PlatformTestScenarios'
// import PlatformAdjustBetScenarios from './PlatformAdjustBetTestScenarios'
import PlatformBetNSettleTestScenarios from './PlatformBetNSettleTestScenarios'

import SEXYBCRTTestScenarios from './SEXYBCRTTestScenarios'
import SV388TestScenarios from './SV388TestScenarios'
import E1SPORTTestScenarios from './E1SPORTTestScenarios'
import HORSEBOOKTestScenarios from './HORSEBOOKTestScenarios'
import KINGMAKERTABLETestScenarios from './KINGMAKERTABLETestScenarios'
import SPADESLOTTestScenarios from './SPADESLOTTestScenarios'
import AELOTTOTestScenarios from './AELOTTOTestScenarios'
import BGTestScenarios from './BGTestScenarios'
import SABAOLDTestScenarios from './SABAOLDTestScenarios'
import SABATestScenarios from './SABATestScenarios'
import AELIVECOMMTestScenarios from './AELIVECOMMTestScenarios'
import PGSLOTMIXEDTestScenarios from './PGSLOTMIXEDTestScenarios'
import VRLOTTOTestScenarios from './VRLOTTOTestScenarios'
import JOKERTestScenarios from './JOKERTestScenarios'
import INSPORTSTestScenarios from './INSPORTSTestScenarios'
import PPLIVETestScenarios from './PPLIVETestScenarios'
import PPTABLETestScenarios from './PPTABLETestScenarios'
import PINOYPERYAHANTestScenarios from './PINOYPERYAHANTestScenarios'
import DCSTestScenarios from './DCSTestScenarios'
import PLAYTECHTestScenarios from './PLAYTECHTestScenarios'
import CQ9TestScenarios from './CQ9TestScenarios'

export default {
  ACEWINFISH: PlatformBetNSettleTestScenarios,
  ACEWINSLOT: PlatformBetNSettleTestScenarios,
  AELIVECOMM: AELIVECOMMTestScenarios,
  AELOTTO: AELOTTOTestScenarios,
  AWSEGAME: PlatformBetNSettleTestScenarios,
  AWSSLOT: PlatformBetNSettleTestScenarios,
  AWSTABLE: PlatformBetNSettleTestScenarios,
  AVIATOR: PlatformTestScenarios,
  BG: BGTestScenarios,
  BTG: PlatformTestScenarios,
  CGEGAME: PlatformTestScenarios,
  CGSLOT: PlatformTestScenarios,
  COMBO: PlatformBetNSettleTestScenarios,
  COOLGAME: PlatformTestScenarios,
  CRASH88: PlatformTestScenarios,
  CREEDROOMZ: PlatformTestScenarios,
  CQ9EGAME: CQ9TestScenarios,
  CQ9FISH: CQ9TestScenarios,
  CQ9SLOT: CQ9TestScenarios,
  CQ9TABLE: CQ9TestScenarios,
  DRAGOONSOFT: PlatformTestScenarios,
  E1SPORT: E1SPORTTestScenarios,
  EVOLUTION: PlatformTestScenarios,
  FASTSPINFISH: PlatformBetNSettleTestScenarios,
  FASTSPINSLOT: PlatformTestScenarios,
  FCEGAME: PlatformBetNSettleTestScenarios,
  FCFISH: PlatformBetNSettleTestScenarios,
  FCSLOT: PlatformBetNSettleTestScenarios,
  FIVEG: PlatformTestScenarios,
  GOGOLI: PlatformTestScenarios,
  GTFFISH: PlatformBetNSettleTestScenarios,
  GTFSLOT: PlatformBetNSettleTestScenarios,
  HABANEROEGAME: PlatformTestScenarios,
  HABANEROSLOT: PlatformBetNSettleTestScenarios,
  HACKSAWEGAME: DCSTestScenarios,
  HACKSAWSLOT: DCSTestScenarios,
  HORSEBOOK: HORSEBOOKTestScenarios,
  HOTROAD: PlatformTestScenarios,
  IDNSLOT: PlatformTestScenarios,
  ILOVEU: PlatformBetNSettleTestScenarios,
  INSPORTS: INSPORTSTestScenarios,
  JDBEGAME: PlatformBetNSettleTestScenarios,
  JDBFISH: PlatformBetNSettleTestScenarios,
  JDBSLOT: PlatformBetNSettleTestScenarios,
  JDBTABLE: PlatformTestScenarios,
  JILIFISH: PlatformBetNSettleTestScenarios,
  JILISLOT: PlatformBetNSettleTestScenarios,
  JILITABLE: PlatformTestScenarios,
  JJEGAME: PlatformTestScenarios,
  JJSLOT: PlatformTestScenarios,
  JOKER: JOKERTestScenarios, // bet / settle + betNSettle with bonus & jackpot
  KINGMAKERMINI: KINGMAKERTABLETestScenarios,
  KINGMAKERSLOT: PlatformTestScenarios,
  KINGMAKERTABLE: KINGMAKERTABLETestScenarios,
  LADYLUCK: PlatformTestScenarios,
  LETSGO: PlatformTestScenarios,
  LUCKY365EGAME: PlatformTestScenarios,
  LUCKY365SLOT: PlatformBetNSettleTestScenarios,
  LUCKYPOKER: PlatformTestScenarios,
  LUDO: PlatformTestScenarios,
  MAC88: PlatformTestScenarios,
  MGEGAME: PlatformTestScenarios,
  MGLIVE: PlatformTestScenarios,
  MGSLOT: PlatformTestScenarios,
  MICROSLOTEGAME: PlatformTestScenarios,
  MICROSLOTSLOT: PlatformTestScenarios,
  MIMIEGAME: PlatformTestScenarios,
  MIMISLOT: PlatformTestScenarios,
  MT: CQ9TestScenarios,
  NEXTSPIN: PlatformTestScenarios,
  NETENTSLOT: PlatformTestScenarios,
  NETENTTABLE: PlatformTestScenarios,
  NLC: PlatformTestScenarios,
  OCTOPLAY: DCSTestScenarios,
  ODIN: PlatformBetNSettleTestScenarios,
  PENGUINKING: DCSTestScenarios,
  PGSLOT: PlatformBetNSettleTestScenarios,
  PGSLOTMIXED: PGSLOTMIXEDTestScenarios,
  PGSLOTOLD: PlatformTestScenarios,
  PGTABLE: PlatformBetNSettleTestScenarios,
  PINNACLE: SABATestScenarios,
  PINOYPERYAHAN: PINOYPERYAHANTestScenarios,
  PLAY8FISH: PlatformBetNSettleTestScenarios,
  PLAY8SLOT: PlatformBetNSettleTestScenarios,
  PLAYNGOBINGO: DCSTestScenarios,
  PLAYNGOEGAME: DCSTestScenarios,
  PLAYNGOSLOT: DCSTestScenarios,
  PLAYNGOTABLE: DCSTestScenarios,
  PLAYSTAR: PlatformTestScenarios,
  PLAYTECHLIVE: PLAYTECHTestScenarios,
  PLAYTECHSLOT: PLAYTECHTestScenarios,
  PLAYTECHTABLE: PLAYTECHTestScenarios,
  PLAYTECHEGAME: PLAYTECHTestScenarios,
  PPEGAME: PlatformTestScenarios,
  PPLIVE: PPLIVETestScenarios,
  PPSLOT: PlatformBetNSettleTestScenarios, // bet / settle + betNSettle with jackpot
  PPTABLE: PPTABLETestScenarios,
  PTLIVE: PlatformTestScenarios,
  PTSLOT: PlatformTestScenarios,
  RELAXEGAME: DCSTestScenarios,
  RELAXSLOT: DCSTestScenarios,
  RELAXTABLE: DCSTestScenarios,
  RICH88EGAME: PlatformTestScenarios,
  RICH88SLOT: PlatformTestScenarios,
  RICH88TABLE: PlatformTestScenarios,
  ROYALGAMING: PlatformTestScenarios,
  RTSLOT: PlatformTestScenarios,
  RTTABLE: PlatformTestScenarios,
  SABA: SABATestScenarios,
  SABAOLD: SABAOLDTestScenarios,
  SEXYBCRT: SEXYBCRTTestScenarios,
  SEXYBCRT_ONEDAY: SEXYBCRTTestScenarios,
  SEXYBCRT_SUMMARY: SEXYBCRTTestScenarios,
  SKYCASINO: SEXYBCRTTestScenarios,
  SMARTSOFT: PlatformTestScenarios,
  SPADEEGAME: PlatformTestScenarios,
  SPADEFISH: PlatformBetNSettleTestScenarios,
  SPADESLOT: SPADESLOTTestScenarios,
  SPRIBE: PlatformTestScenarios,
  SV388: SV388TestScenarios,
  TADAEGAME: PlatformTestScenarios,
  TADAFISH: PlatformBetNSettleTestScenarios,
  TADASLOT: PlatformBetNSettleTestScenarios,
  TADATABLE: PlatformTestScenarios,
  THREEOAKS: PlatformBetNSettleTestScenarios,
  VENUS: SEXYBCRTTestScenarios,
  VIACASINO: PlatformTestScenarios,
  VRLOTTO: VRLOTTOTestScenarios,
  WINFINITY: PlatformTestScenarios,
  YESBINGOBINGO: PlatformTestScenarios,
  YESBINGOEGAME: PlatformTestScenarios,
  YESBINGOFISH: PlatformBetNSettleTestScenarios,
  YESBINGOSLOT: PlatformTestScenarios,
  YGGDRASILSLOT: DCSTestScenarios,
  YGGDRASILTABLE: DCSTestScenarios,
  YLEGAME: PlatformTestScenarios,
  YLFISH: PlatformBetNSettleTestScenarios,
}
